// extracted by mini-css-extract-plugin
export default {"taskModal":"CreateTaskModal_taskModal__mtRCT","datePicker":"CreateTaskModal_datePicker__FflWj","typeDescription":"CreateTaskModal_typeDescription__C9-t5"};